<template>
    <div @mouseleave="delayClose"
         @mouseenter="cancelClose"
         class="z-40"
         ref="itemicon"
         :key="faIconclass"
    >
        <div @click="openIconSubmenu">
            <slot name="default" ref="opener"></slot>
        </div>
        <div class="absolute z-40" style="width:auto;height:auto;overflow: visible"
             :ref="'itemiconrelative'">
            <vue-context :ref="'itemiconmenu'" :autoFocus="false"
                         class="inline pb-0 focus:outline-none focus:ring-0 z-30"
                         :close-on-click="false" :close-on-scroll="false">
                <div :id="'itemiconmenu'"
                     class="p-3 w-96 z-30 bg-white rounded-lg border border-gray-300 shadow-lg">
                    <input
                        class="m-0 mb-2 relative rounded-md shadow-sm block w-full border border-gray-300 sm:text-sm focus:outline-none focus:ring-brand focus:border-brand"
                        :placeholder="'Search for icon...'"
                        :type="'text'"
                        ref="search"
                        autocomplete="false"
                        spellcheck="false"
                        @keydown.enter.prevent
                        v-model="searchText"
                        @input="updateIcons"
                    >
                    <div class="-ml-0 w-96" v-if="currentIcons.length">
                        <div
                            v-for="(icon,index) in currentIcons"
                            class="w-14 inline-block items-center py-2 px-0 border border-none rounded-lg mx-0.5"
                            :key="icon.name">
                            <button
                                class="w-12 h-12 text-2xl rounded-lg flex-none m-0 inline-block border border-gray-300 hover:border-gray-400"
                                @click="selectIcon(icon)">
                                <i :class="getFaClassname(icon)"></i>
                            </button>
                        </div>
                    </div>
                    <div v-else class="text-center text-gray-300">No Icons found</div>
                </div>
            </vue-context>
        </div>
    </div>
</template>

<script>

import UiDropdownItem from "./UiDropdownItem.vue";
import {faIcons} from "../../utils";

export default {
    name: 'UiIconPicker',
    components: {UiDropdownItem},
    props: {
        readonly: false,
        faIconclass: null
    },
    data() {
        return {
            allIcons: [],
            currentIcons: [],
            searchText: '',
            closeTimeout: false
        }
    },
    methods: {
        openIconSubmenu(e) {
            if (this.readonly) return;
            this.allIcons = faIcons()
            this.updateIcons()
            this.$refs["itemiconmenu"].open(new window.MouseEvent('mouse'))
            this.$nextTick(() => {
                this.$refs["itemiconrelative"].setAttribute('style', '')
                this.$nextTick(() => {
                    const opener = this.$refs.itemicon.getBoundingClientRect()
                    const box = this.$refs.itemicon.getBoundingClientRect()
                    let left = Math.min(opener.x - box.x + 16, window.innerWidth - (box.right) - 8);
                    let top = Math.min(opener.y - box.y - 16, window.innerHeight - (box.bottom) - 8);
                    this.$refs["itemiconrelative"].setAttribute('style', 'margin-left:' + left + 'px; margin-top:' + top + 'px')
                    this.$refs["search"].focus()
                })
            })
        },
        selectIcon(icon) {
            this.$emit('selected', this.getFaClassname(icon))
            this.close()
        },
        delayClose(){
            this.closeTimeout = setTimeout(() => this.close(),300)
        },
        cancelClose(){
            clearTimeout(this.closeTimeout)
        },
        close() {
            this.$refs['itemiconmenu'].close()
        },
        updateIcons() {
            let icons = this.allIcons;
            if (this.searchText.trim()) {
                let query = this.searchText.toLowerCase().trim().split(' ')
                icons = icons.filter((i) => {
                    return query.every((token) => {
                        return i.search.terms.some((i2) => i2.toLowerCase().includes(token)) || i.name.toLowerCase().includes(token) || i.label.toLowerCase().includes(token)
                    })
                })
            }
            this.currentIcons = icons.slice(0, 24)
        },
        getFaClassname(icon) {
            return 'fa' + icon.styles[0].substr(0, 1) + ' fa-' + icon.name
        }
    },
    created() {
    },
    computed: {},

};
</script>

<style lang="scss" scoped>
</style>
